<template>
  <div class="company-info df fdc">

    <h2>Upgrade to <strong>Unlimited</strong></h2>
    <p class="plan-subheading">You have selected to change your plan from <strong>{{$store.getters.companyPlan == 'plan_G91aW03VrSu7x8' ? 'Basic' : 'Free'}}</strong> to <strong>Unlimited</strong>. Starting today you will be charged $150/month to your credit card. Please review the details below.</p>

    <div class="pricing-plan df fdr jcsb">
      <span class="pricing-plan-left f2 df fdc aic jcsb plan-title">
        <span>
          <p>Unlimited</p>
          <p class="plan-price">$150<sup>mo</sup></p>
        </span>
        <!-- <button class="button button-1 button-black" v-on:click="goTo('/changeplan')">Upgrade Plan</button> -->
      </span>
      <span class="pricing-plan-right df fdr f4 jcsb">
        <!-- <span class="df fdc f1 jcsb">
          <p class="f1">Unlimited Users</p>
          <p class="f1 number-of-things">&nbsp;</p>
        </span> -->
        <span class="df fdc f1 jcsb">
          <p class="f1">Unlimited Projects</p>
          <p class="f1 number-of-things">&nbsp;</p>
        </span>
        <span class="df fdc f1 jcsb">
          <p class="f1">
            Features
          </p>
          <p class="f1">
            <span class="feature">Edit task rates</span>
            <span class="feature">Edit roles</span>
            <span class="feature">Edit resources</span>
            <span class="feature">Edit groups</span>
            <span class="feature">Phases</span>
            <span class="feature">Harvest Integration</span>
            <span class="feature">Export to Excel</span>
            <span class="feature">Export to Sheets</span>
            <span class="feature">Data Analysis</span>
          </p>
        </span>
      </span>
    </div>

    <div class="box df fdc">
      <div class="plan-row df fdr jcsb">
        <p>Plan</p>
        <p>Price</p>
      </div>
      <div class="plan-row df fdr jcsb">
        <p class="plan-title">Unlimited Plan</p>
        <div class="df fdr">
          <!-- <div class="df fdc jcfe mrx">
            <p>Tax 15%</p>
          </div> -->
          <div class="df fdc jcsb prices">
            <p>
              $150.00
            </p>
            <!-- <p>
              $22.50
            </p> -->
          </div>
        </div>
      </div>
      <hr/>
      <div class="plan-row df fdr jcsb total-row">
        <p class="plan-title"></p>
        <div class="df fdr">
          <div class="df fdc jcfe mrx">
            <p>Total</p>
          </div>
          <div class="df fdc jcsb prices">
            <p>
              $150
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="page1 profile f1 box">
      <div class="basic-profile">
        <!-- <div class="form-row df fdr">
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Payment Type</p>
              <input v-on:input="changesMade()" value="Credit Card" disabled size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>&nbsp;</p>
              <input v-on:input="changesMade()" placeholder="A1B 2C3" v-model="postalCode" size="10" class="input1" type="text">
            </span>
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text">
          </span>
        </div> -->
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Name on Card</p>
            <input v-on:input="changesMade()" v-model="name" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
            <!-- <span class="input-wrapper df fdc">
              <p>Province</p>
              <input v-on:input="changesMade()" placeholder="ON" v-model="province" size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>Zip/Postal Code</p>
              <input v-on:input="changesMade()" placeholder="A1B 2C3" v-model="postalCode" size="10" class="input1" type="text">
            </span> -->
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Card Number</p>
            <input v-mask="'####-####-####-####'" v-bind:placeholder="'**** **** **** ' + (last4 || '****')" v-on:input="changesMade()" v-model="cardNumber" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Expiry Date</p>
              <input v-on:input="changesMade()" v-mask="'##/####'" placeholder="01/2023" v-model="expiry" size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>CVC</p>
              <input v-on:input="changesMade()" v-mask="'####'" placeholder="123" v-model="cvc" size="10" class="input1" type="text">
            </span>
          </span>
        </div>
        <h4 class="mt0">Billing</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Address</p>
            <input v-on:input="changesMade()" v-model="address" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Country</p>
            <input v-on:input="changesMade()" v-model="country" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Province</p>
              <input v-on:input="changesMade()" placeholder="ON" v-model="province" size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>Zip/Postal Code</p>
              <input v-on:input="changesMade()" placeholder="" v-model="postalCode" size="10" class="input1" type="text">
            </span>
          </span>
        </div>
        <div class="form-row payment-error-row df fdr">
          <p class="payment-error">
            {{ error }}
          </p>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <button v-if="changingPlan" class="button-form button-form-active">Updating Plan</button>
            <button v-else class="button-form button-form-active" v-on:click="changePlan()">{{this.$store.getters.upgradeOrDowngrade('plan_G91cFxeIzg5lCq')}}</button>
          </span>
          <span class="input-wrapper df fdc">
            <button class="button-form button-form-active" v-on:click="goTo('/pricing')">Cancel</button>
          </span>
        </div>
      </div>


    </div>


  </div>
</template>

<script>
import router from '../../router'
const axios = require('axios')

export default {
  name: 'CompanyChangePlan',
  data () {
    return {
      profileChangesMade: false,
      name: this.$store.getters.userData.nameBilling,
      cardNumber: '',
      expiry: '',
      cvc: '',
      last4: '',
      address: this.$store.getters.userData.addressBilling,
      city: this.$store.getters.userData.cityBilling,
      country: this.$store.getters.userData.countryBilling,
      province: this.$store.getters.userData.provinceBilling,
      postalCode: this.$store.getters.userData.postalCodeBilling,
      changingPlan: false
    }
  },
  props: ['error'],
  components: {

  },
  methods: {
    changesMade () {
      this.profileChangesMade = true
    },
    changePlan () {
      var validateDate = (v) => {
        var filter = new RegExp("(0[123456789]|10|11|12)([/])([1-2][0-9][0-9][0-9])");
        return filter.test(v)
      }

      var data = {
        company: this.$store.getters.myCompany,
        uid: this.$store.getters.uid,
        name: this.name,
        cardNumber: this.cardNumber.length == 19 ? this.cardNumber : '1',
        expiry: validateDate(this.expiry) ? this.expiry : '12/2012',
        cvc: this.cvc.length == 3 ? this.cvc : '1',
        address: this.address,
        city: this.city,
        last4: '',
        country: this.country,
        province: this.province,
        postalCode: this.postalCode,
        email: this.$store.getters.userData.email,
        description: 'Account for ' + this.name,
        plan: 'plan_G91cFxeIzg5lCq'
      }
      this.changingPlan = true
      // setTimeout(() => {
        this.changingPlan = false
      // }, 15000)
      this.$emit('changePlan', data)
    },
    goTo (path) {
      console.log('GOINT TO...', path)
      router.push(path)
    },

    getBillingDetailsFromProvider () {
      console.log('getBillingDetailsFromProvider')
      var _this = this

      var data = {
        uid: this.$store.getters.billingID
      }

      axios.get('/getexistingclient', {
        params: {
          format: 'json',
          data
        }
      })
      .then(function (response) {
        // console.log('response', response);
        console.log('RESPONSE 1', response)
        var user = response.data.billingData
        console.log('user', user)
        _this.name = user.name
        _this.address = user.address
        _this.city = user.city
        _this.province = user.province
        _this.country = user.country
        _this.postalCode = user.postalCode
        _this.last4 = user.last4 || ''
      })
      .catch(function (error) {
        console.log('ERROR 1', error.response);
      })
      .then(function () {
        // always executed
      }); 
    }
  },
  computed: {

  },
  created () {
    console.log('** CompanyChangePlan Loaded **')
    setTimeout(()=>{this.getBillingDetailsFromProvider()}, 1500)
    // try getting current user
      // exists - populate, set currentUser, requests will go to /update...
      // doesn't exist - requests will go to /create...
  }
}
</script>

<style scoped lang="scss">
  
  h2 {
    color: black;
  }

  .company-info {
    padding: 40px;

    & > .box {
      padding: 40px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .plan-subheading {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .wrapper {
    width: 100%;
  }
  .pricing-plan {
    min-height: 210px;
    margin-bottom: 50px;
  }
  .pricing-plan-left {
    background-color: #D9EDFF;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 40px 0;
  }
  .pricing-plan-right {
    background-color: white;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    & > span {
      padding: 40px;
      &:last-child {
        & > p {
          &:first-child {
            margin-bottom: 40px;
          }
        }
      }
    }
  }
  .feature {
    display: block;
    margin-bottom: 4px;
  }
  .number-of-things {
    color: #000000;
    font-size: 48px;
    line-height: 57px;
  }
  .plan-price {
    color: #000000;
    font-size: 48px;
    line-height: 57px;
    position: relative;
    text-align: center;
    margin-top: 10px;

    & > sup {
      position: absolute;
      top: 14px;
      text-transform: uppercase;
      color: #000000;
      font-size: 14px;
      line-height: 4px;
    }
  }
  .plan-heading {
    color: #000000;
    font-size: 24px;
    line-height: 43px;
    margin-bottom: 5px;
  }

  .plan-row {
    margin-bottom: 10px;

    &:first-of-type {
      font-weight: 600;
    }

    &:last-of-type {
      margin-top: 15px;
      margin-bottom: 0;
    }
  }
  .plan-title {
    color: #000000;
    font-size: 36px;
    line-height: 42px;
  }
  .mrx {
    margin-right: 25px;
  }
  .prices {
    text-align: right;
  }
  hr {
    height: 1px;
    width: 100%;
    border: 0;
    background-color: #ccc;
  }
  .total-row {
    font-weight: 600;
  }
  h4 {
  margin-top: 75px;

  & > first-child {
    margin-top: 0;
  }
}

.wrapper {
  width: 100%;
  min-height: unset;
}

.profile {
  padding: 50px;
}

.form-row {
  width: 100%;

  & > span {
  }
}

.payment-error-row {
  margin-bottom: 24px;

  p {
    font-size: 20px;
    font-weight: 500;
    color: #dd5050;
  }
}

.input-wrapper {
  margin-bottom: 20px;
  margin-right: 40px;
  flex: 1;

  & > p {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
  }
}

.input-wrapper-inner {
  flex: 1px;
  width: 50%;

  & > span {
    margin-right: 0;

    &:first-child {
      margin-right: 30px;
    }
  }
}

.delete-account-text {
  color: #000000;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
  margin-bottom: 30px;
}

.profile-photo-inner {
  border-radius: 8px;
  background-color: white;
  padding: 50px;
  margin-right: 30px;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.32);
}

.profile-image {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-position: center;
  object-fit: cover;
}

.profile-photo-details {
  flex: 1;
  margin-left: 50px;
}

.photo-buttons {
  & > button {
    &:first-child {
      margin-right: 40px;
    }
  }
}

</style>
